import React from 'react';

export default () => (
  <svg width="72" height="56" viewBox="0 0 72 56" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path 
    d="M22.848 43.936L66.24 0.543945L72 6.30395L22.848 55.456L0 32.608L5.76 26.8479L22.848 43.936Z" 
    // fill="currentColor"
  />
  </svg>
)

